module.exports = __webpack_public_path__ + "img/glasses3.211e2345.png";